export default __webpack_public_path__ + "static/0054-5500df8bc3abc740dab14da0118d1e9f.png";